import React, { useState, useEffect } from 'react';
import { Column, Container, Image } from '@codeparva/ui-components-library';
import { CardSection } from './components/card/Card';
import { Background } from './components/background/Background';
import { JumbotronTypes } from './jumbotronTypes';
import { VariantContext } from '../helper/Context';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import { LocationMap } from '../../../sitewide/components/locationMap/LocationMap';
import { JumbotronContext } from './context/jumbotronContext';
import { Gallery } from '../../../../components/gallery/Gallery';
import { CPImage } from '../../../../components/imageWrapper/CPImage';
import Carousel, { CarouselItem } from './components/carousel/Carousel';
import { weakKey } from '../../../../utilities/weakKey';
import { desktopscreensize } from '../../../../utilities/constants';

export const Jumbotron = ({
  variant,
  contactDetails,
  media,
  cardSectionImages,
  textOverlay,
  locationMapConfig,
  headHeight,
  cardDropDown,
  accordion,
  jumbotron_subtitle = {},
}: JumbotronTypes.IJumbotron) => {
  const { width } = useWindowDimensions();
  const [locationData, setLocationData] = useState(contactDetails);
  const [locationMapData, setLocationMapData] = useState<any>([
    locationMapConfig.locations[0],
  ]);
  const [isLocationMap, setIsLocationMap] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<any>(
    contactDetails[0]
  );
  const JumbotronHeight = (width * 6) / 16;
  useEffect(() => {
    let res = locationMapConfig.locations.map(location => {
      if (location.facilityName == selectedLocation.locationName) {
        return location;
      }
    });
    res = res.filter(function(element) {
      return element !== undefined;
    });
    setLocationMapData(res);
    setIsLocationMap(true);
  }, [selectedLocation]);

  const renderSingleImage = (media: any, maxWidth: any) => (
    <>
      {media[0].gatsbyImageData ? (
        <CPImage
          gatsbyImageData={media[0].gatsbyImageData}
          className="aboutUsCPImage"
        />
      ) : (
        <Image
          src={media[0].imageUrl}
          size={maxWidth}
          fullwidth={maxWidth === 'full-size'}
          style={{
            width: '100%',
            height: '100%',
            maxWidth: maxWidth !== 'full-size' ? maxWidth : undefined,
          }}
        />
      )}
    </>
  );

  const renderCarousel = (media: any, maxWidth: any) => (
    <>
      <Carousel>
        {media &&
          media.map((imagesSrc: any) => (
            <CarouselItem width="100%" key={weakKey(imagesSrc)}>
              <div className="customArtContainer">
                {imagesSrc.gatsbyImageData ? (
                  <CPImage gatsbyImageData={imagesSrc.gatsbyImageData} />
                ) : (
                  <Image
                    src={imagesSrc.imageUrl}
                    size={maxWidth}
                    fullwidth={maxWidth === 'full-size'}
                    style={{
                      maxWidth: maxWidth !== 'full-size' ? maxWidth : undefined,
                    }}
                  />
                )}
              </div>
            </CarouselItem>
          ))}
      </Carousel>
    </>
  );

  const ImageVariant = () => {
    return (
      <Column size={width > desktopscreensize ? 4 : 12} className="m-auto">
        {cardSectionImages?.images?.length === 1 ? (
          renderSingleImage(
            cardSectionImages?.images,
            cardSectionImages?.maxWidth
          )
        ) : cardSectionImages?.images?.length <= 4 ? (
          <Gallery
            variant="imageWithButton"
            media={cardSectionImages?.images}
          />
        ) : (
          renderCarousel(cardSectionImages?.images, cardSectionImages?.maxWidth)
        )}
      </Column>
    );
  };

  const renderTemplate2 = (templateVariant: JumbotronTypes.TVariant) => {
    const height = width >= 1408 ? JumbotronHeight : headHeight;
    return (
      <div className="JumbotronTemplate is-flex is-flex-direction-column">
        <Background
          media={media}
          locationMapConfig={locationMapConfig}
          headHeight={height}
          variant={templateVariant}
          contactDetails={contactDetails}
          setLocationData={setLocationData}
          setSelectedLocation={setSelectedLocation}
          width={width}
        />
        <Container
          className={`JumbotronCard is-fullwidth ${
            variant === 'multiLocationDropDown' ? '' : 'MarginTop'
          } ${
            cardSectionImages?.images ||
            locationMapData?.hasOwnProperty('iframeUrl')
              ? 'JumbotronCardsGap'
              : ''
          }`}
        >
          <CardSection
            accordion={accordion}
            contactDetails={contactDetails}
            textOverlay={textOverlay}
            cardDropDown={cardDropDown}
            variant={templateVariant}
          />
          {cardSectionImages?.images ? (
            <ImageVariant />
          ) : (
            <div className="mapSection is-cp-w-100">
              {(isLocationMap || locationMapData) &&
              templateVariant !== 'singleLocation' ? (
                <>
                  <LocationMap {...locationMapConfig} />
                </>
              ) : (
                <></>
              )}
            </div>
          )}
        </Container>
      </div>
    );
  };

  const renderTemplate = () => {
    if (contactDetails.length > 1) {
      const templateVariant = variant.includes('multi')
        ? variant
        : 'multiLocation';
      return renderTemplate2(templateVariant);
    } else {
      const templateVariant = variant.includes('single')
        ? variant
        : 'singleLocation';
      return renderTemplate2(templateVariant);
    }
  };
  const jumbotronContextValue = {
    locationData,
    selectedLocation,
    variantType: variant.includes('multi') ? 'multi' : 'single',
    jumbotron_subtitle,
  };
  return (
    <VariantContext.Provider value={variant}>
      <JumbotronContext.Provider value={jumbotronContextValue}>
        {renderTemplate()}
      </JumbotronContext.Provider>
    </VariantContext.Provider>
  );
};
